import { createSlice } from "@reduxjs/toolkit";
import { getAnnouncements } from "../actions/announcements.actions";
import { AnnouncementApi } from "../../interfaces/Announcement.types";

const initialState = {
  announcements: [] as AnnouncementApi[],
  loading: false,
  error: null as unknown | null,
};
export const announcementsSlice = createSlice({
  name: "announcements",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAnnouncements.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAnnouncements.fulfilled, (state, action) => {
        state.announcements = action.payload ?? [];
        state.loading = false;
      })
      .addCase(getAnnouncements.rejected, (state, action) => {
        state.announcements = [];
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default announcementsSlice.reducer;
